import React from 'react';
import { Message } from 'semantic-ui-react';
import {useAuthStore} from '../stores/useAuthStore';

const renderError = (msg) => {
    if (msg.length > 0) {
        return (
            <Message negative>
                {msg}
            </Message>
        );
    }
    return null;
}

const ErrorMsg = () => {
    const errors = useAuthStore(state => state.errors);
    return renderError(errors);
};

export default ErrorMsg;